var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3519 2.63672C16.1557 0.454428 12.5939 0.454428 10.3977 2.63672L1.27919 11.585C-0.426396 13.2788 -0.426396 16.0358 1.27919 17.7296C2.98477 19.4235 5.76033 19.4235 7.46529 17.7296L16.5838 8.78076C17.8044 7.56859 17.8044 5.60416 16.5838 4.39198C15.3632 3.18043 13.3845 3.18043 12.1652 4.39198L5.31034 11.1995C5.06597 11.4428 5.06597 11.8345 5.31034 12.0778C5.55471 12.3205 5.9497 12.3205 6.19407 12.0778L13.0495 5.26961C13.7808 4.54405 14.9695 4.54405 15.7007 5.26961C16.432 5.9958 16.432 7.17694 15.7007 7.90313L6.58219 16.8514C5.36159 18.0636 3.38414 18.0636 2.16354 16.8514C0.942947 15.6398 0.942947 13.6748 2.16354 12.4632L11.1927 3.60186C12.9014 1.90494 15.6726 1.90494 17.3788 3.60186C19.0888 5.29941 19.0888 8.04899 17.3801 9.74591L10.614 16.4659C10.3684 16.7092 10.3684 17.1009 10.614 17.3436C10.8583 17.5869 11.2533 17.5869 11.4977 17.3436L18.3519 10.536C20.5494 8.35498 20.5494 4.81776 18.3519 2.63672Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.791d1af0d6a298fed1dcf8e57adf102d.svg";
export { ForwardRef as ReactComponent };